// The minimum amount for processing a transaction through Stripe in USD is $0.50
export const STRIPE_MINIMUM_TRANSACTION_AMOUNT = 50;
/**
 * Offered next to a declined-payment message so the payer can read what their decline means and
 * what to do about it. The page covers every decline code, which is deliberate: Stripe asks us
 * not to say which one we got when the card is reported lost, stolen or fraudulent.
 */
export const STRIPE_DECLINE_CARD_DOC_URL = 'https://docs.stripe.com/declines/card';
/** What that link says, in place of the client's plainer default. */
export const STRIPE_DECLINE_CODES_LINK_TEXT = 'Learn why payments are declined';
export const StripeReason = {
    newPaymentMethod: 'newPaymentMethod',
    verificationRequestPayment: 'verificationRequestPayment',
    transfer: 'transfer',
};
export const StripePaymentMethodType = {
    card: 'card',
    ach: 'us_bank_account',
};
export const StripePaymentIntentEventType = {
    AmountCapturableUpdated: 'payment_intent.amount_capturable_updated',
    Canceled: 'payment_intent.canceled',
    Created: 'payment_intent.created',
    PartiallyFunded: 'payment_intent.partially_funded',
    PaymentFailed: 'payment_intent.payment_failed',
    Processing: 'payment_intent.processing',
    RequiresAction: 'payment_intent.requires_action',
    Succeeded: 'payment_intent.succeeded',
};
export const StripeTransferEventType = {
    Created: 'transfer.created',
};
export const StripePaymentHistoryDetails = {
    newPaymentMethod: 'New payment method added',
    verificationRequestPayment: 'Verification request payment',
};
export const StripeTransferGroup = {
    VerificationRequestRevenueShare: 'VerificationRequestRevenueShare',
};
//# sourceMappingURL=stripe.js.map